import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowAlignVerticalCentre24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconArrowAlignVerticalCentre24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M21.25 12.75a.75.75 0 0 0 0-1.5h-4.94l2.22-2.22a.75.75 0 0 0-1.06-1.06l-3.536 3.535-.53.53.53.53 3.536 3.536a.75.75 0 1 0 1.06-1.06l-2.29-2.291zM12 4a.75.75 0 0 1 .75.75v14.5a.75.75 0 0 1-1.5 0V4.75A.75.75 0 0 1 12 4M2 12.071a.75.75 0 0 1 .75-.75h5.01l-2.29-2.29A.75.75 0 0 1 6.53 7.97l3.536 3.535.53.53-.53.53-3.536 3.536a.75.75 0 1 1-1.06-1.06l2.22-2.22H2.75a.75.75 0 0 1-.75-.75"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowAlignVerticalCentre24);
